import { defineStore } from "pinia";
import { cloneDeep, merge } from "lodash";
import type { roleType, roleUserType } from "@/types/role";
import { getRoleList } from "@/api/apiclient/application";

export const useRole = defineStore("role", {
  state: () => {
    return {
      // If the model evolves into having nested references we avoid gotchas
      current: cloneDeep({}),
      list: [] as roleUserType[],
    };
  },
  actions: {
    setCurrent(item: roleType): void {
      this.current = merge(this.current, item);
    },
    async loadList() {
      const list = await getRoleList();
      if (list && list.length > 0) {
        this.list = list;
      }
    },
    resetCurrent(): void {
      this.current = cloneDeep({});
    },
    resetList(): void {
      this.list = [];
    },
    publicNameFromRoleId(id: number): string {
      return this.list.find((role) => role.id === id)?.description ?? "";
    },
    nameFromRoleId(id: number): string {
      return this.list.find((role: roleUserType) => role.id === id)?.name?.toString() ?? "";
    },
  },
  getters: {
    // rolesMap(): any {
    //   return this.list.reduce((acc, curr:roleType ) => {
    //     if( curr.name ){
    //       acc[curr.name] = rolesTranslations[curr.name];
    //     }
    //     return acc;
    //   }, {});
    // },
    // /**
    //  * Create a usable array for <select> components.
    //  */
    // rolesOptions: (state) =>
    //   state.list.map<{ text: string; value: number }>((role) => {
    //     return {
    //       text: rolesTranslations[role.name] ?? role.name,
    //       value: role.id,
    //     };
    //   }),
    idForRole(state): any {
      return (roleName: string) => state.list.find((role) => role.name === roleName)?.id;
    },
    getNameFromId(state) {
      return (id: number): string => {
        return state.list.find((i) => i.id == id)?.name ?? "";
      };
    },
    getDescriptionFromId(state) {
      return (id: number): string => {
        console.log(id)
        return state.list.find((i) => i.id == id)?.description ?? "";
      };
    },
  },
});
